var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hub-switch__container"},[_c('v-switch',_vm._b({attrs:{"inset":""},model:{value:(_vm.switchState),callback:function ($$v) {_vm.switchState=$$v},expression:"switchState"}},'v-switch',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }